import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface ResponsiveContainerProps {
  variant: 'narrow' | 'standard' | 'wide' | 'full';
  children: ReactNode;
  className?: string;
}

const containerVariants = {
  narrow: "max-w-md mx-auto lg:max-w-lg xl:max-w-xl",
  standard: "max-w-md mx-auto lg:max-w-2xl xl:max-w-4xl",
  wide: "max-w-md mx-auto lg:max-w-4xl xl:max-w-6xl",
  full: "w-full"
};

export function ResponsiveContainer({ 
  variant, 
  children, 
  className 
}: ResponsiveContainerProps) {
  return (
    <div className={cn(containerVariants[variant], className)}>
      {children}
    </div>
  );
}